const DB_NAME = 'sales_counter_db'
const DB_VERSION = 2
const STORE_QUEUE = 'sales_queue'
const STORE_META = 'sales_queue_meta'
const META_LAST_SYNC = 'last_sync_at'

let dbPromise = null

function ensureIndex(store, name, keyPath, options = {}) {
  if (!store.indexNames.contains(name)) {
    store.createIndex(name, keyPath, options)
  }
}

function openDb() {
  if (dbPromise) return dbPromise

  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB no disponible'))
      return
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onupgradeneeded = event => {
      const db = event.target.result

      if (!db.objectStoreNames.contains(STORE_QUEUE)) {
        const queue = db.createObjectStore(STORE_QUEUE, { keyPath: 'id' })
        ensureIndex(queue, 'status', 'status', { unique: false })
        ensureIndex(queue, 'enqueuedAt', 'enqueuedAt', { unique: false })
        ensureIndex(queue, 'cashIds', 'meta.cashIds', { unique: false, multiEntry: true })
        ensureIndex(queue, 'customerName', 'meta.customerName', { unique: false })
      } else {
        const queue = event.target.transaction.objectStore(STORE_QUEUE)
        ensureIndex(queue, 'status', 'status', { unique: false })
        ensureIndex(queue, 'enqueuedAt', 'enqueuedAt', { unique: false })
        ensureIndex(queue, 'cashIds', 'meta.cashIds', { unique: false, multiEntry: true })
        ensureIndex(queue, 'customerName', 'meta.customerName', { unique: false })
      }

      if (!db.objectStoreNames.contains(STORE_META)) {
        db.createObjectStore(STORE_META, { keyPath: 'key' })
      }
    }

    request.onsuccess = event => resolve(event.target.result)
    request.onerror = () => reject(request.error || new Error('No se pudo abrir IndexedDB'))
  })

  return dbPromise
}

function txStore(db, storeName, mode = 'readonly') {
  return db.transaction(storeName, mode).objectStore(storeName)
}

function requestToPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error || new Error('Operación IndexedDB fallida'))
  })
}

const queueStorage = {
  async checkHealth() {
    try {
      await openDb()
      return { ok: true, error: '' }
    } catch(e) {
      return { ok: false, error: e.message || 'IndexedDB no disponible' }
    }
  },

  async loadQueue() {
    try {
      const db = await openDb()
      const store = txStore(db, STORE_QUEUE)
      const items = await requestToPromise(store.getAll())
      return (items || []).sort((a, b) => String(a.enqueuedAt || '').localeCompare(String(b.enqueuedAt || '')))
    } catch(e) {
      return []
    }
  },

  async saveItem(item) {
    try {
      const db = await openDb()
      const store = txStore(db, STORE_QUEUE, 'readwrite')
      await requestToPromise(store.put(item))
      return true
    } catch(e) {
      return false
    }
  },

  async deleteItem(id) {
    try {
      const db = await openDb()
      const store = txStore(db, STORE_QUEUE, 'readwrite')
      await requestToPromise(store.delete(id))
      return true
    } catch(e) {
      return false
    }
  },

  async loadLastSync() {
    try {
      const db = await openDb()
      const store = txStore(db, STORE_META)
      const row = await requestToPromise(store.get(META_LAST_SYNC))
      return row ? row.value : null
    } catch(e) {
      return null
    }
  },

  async saveLastSync(value) {
    try {
      const db = await openDb()
      const store = txStore(db, STORE_META, 'readwrite')
      await requestToPromise(store.put({ key: META_LAST_SYNC, value }))
      return true
    } catch(e) {
      return false
    }
  },
}

export default queueStorage
